export const TEAM_MEMBERS = [
  {
    id: 1,
    name: "Christophe Borbiconi",
    role: "Directeur d'agence",
    description: "Expert immobilier depuis plus de 20 ans, Christophe a fondé SCBI avec la volonté de placer l'humain au cœur de chaque transaction. Sa connaissance parfaite du secteur frontalier est un atout majeur pour votre projet.",
    image: "https://img.netty.immo/company56396pba/assets/nego/001_l.jpg?1768466612",
    phone: "06 11 40 52 99",
    email: "christophe@scbi.fr"
  },
  {
    id: 2,
    name: "Vanessa Tancredi",
    role: "Consultante Immobilier",
    description: "Professionnelle passionnée et ultra réactive, je vous accompagne dans vos projets de vente, d'achat ou d'estimation avec sérieux et engagement. Présente sur Mercy-le-Bas, Piennes, Landres et alentours, comptez sur moi pour un accompagnement sur-mesure.",
    image: "/photo_vanessa.jpg",
    phone: "06 95 07 13 22",
    email: "vanessa@scbi.fr"
  },
  {
    id: 3,
    name: "Jean Dupont",
    role: "Négociateur Immobilier",
    description: "Passionné par l'architecture et le contact humain, Jean saura dénicher la perle rare pour les acquéreurs et négocier au meilleur prix pour les vendeurs.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=400",
    phone: "06 11 22 33 44",
    email: "jean@scbi.fr"
  },
  {
    id: 4,
    name: "Mélanie Pineiro",
    role: "Consultante Immobilier",
    description: "Pour moi, l'immobilier est avant tout une aventure humaine. Spécialisée sur l'axe Metz-Thionville-Luxembourg, je m'implique totalement dans votre projet. Formons ensemble une équipe pour atteindre votre but avec sérieux, écoute et bienveillance.",
    image: "https://img.netty.immo/company56396pba/assets/nego/111_l.jpg?1774353121",
    phone: "06 14 43 29 28",
    email: "melanie@scbi.fr"
  }
];

export const AGENCY_HISTORY = {
  title: "Notre Histoire",
  content: [
    "Fondée sur des valeurs de transparence et de proximité, SCBI Borbiconi Immobilier s'est imposée comme une référence de l'immobilier dans le secteur frontalier d'Ottange.",
    "Depuis notre création, nous avons accompagné des centaines de familles dans leurs projets de vie. Notre agence n'est pas seulement un lieu de transaction, c'est un partenaire de confiance qui comprend les enjeux spécifiques du marché local.",
    "Aujourd'hui, nous continuons d'innover avec des outils modernes tout en gardant l'ADN qui a fait notre succès : un accompagnement sur-mesure et une expertise sans faille."
  ]
};
